/* eslint no-unused-vars: 1 */

/** the data services not a factory to avoid trouble on moving to Angular 2 */
(function() {
    'use strict';
    angular.module('porting').service('providerListService', [ '$http', '$injector', function($http, $injector) {
    	
    	var config = $injector.get('config');
    	
    	var providerList = [];
    	
        function providerListGet() {
            if(!providerList || 0 === providerList.length){
            	providerList = [];
                $http({
                    method: 'GET',
                    url: config.apiURLs.PROVIDERLIST,
                    data: {}
                }).then(function(response){
                	if('undefined' !== typeof response.data && 'undefined' !== typeof response.data.provider_list && 'undefined' !== typeof response.data.provider_list.provider){
                		providerList = response.data.provider_list.provider;
                	}
                });
            }
            
            return providerList;
        };
        
        return {
        	providerListGet: providerListGet
        };
    }
    ]);
    
})();
